module.exports = __webpack_public_path__ + "img/bp12.66fdeb37.jpeg";